import { NAV_LINKS, scrollToId } from "./nav";
import { Phone, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A192F] text-white pt-16 lg:pt-24 pb-8 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-white/10 flex items-center justify-center relative">
                <span className="font-display text-white font-bold text-lg leading-none">
                  Б
                </span>
                <span className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-[#FF6B00]" />
              </div>
              <div className="leading-tight">
                <div className="font-display text-white font-semibold text-lg">
                  Бизора Логистик
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">
                  Оптовые поставки B2B
                </div>
              </div>
            </div>
            <p className="text-white/70 text-base leading-relaxed max-w-md">
              Оптовые B2B-поставки: комплектующие и запчасти, ГСМ, хозяйственные товары,
              промышленная мебель и фурнитура, маломощные электродвигатели и электромеханические
              решения по всей России.
            </p>

            <button
              onClick={() => scrollToId("request")}
              data-testid="footer-cta"
              className="mt-8 group inline-flex items-center gap-2 bg-[#FF6B00] hover:bg-[#E66000] text-white px-6 py-3.5 font-medium transition-colors"
            >
              Оставить заявку
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Навигация
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    data-testid={`footer-nav-${l.id}`}
                    className="text-white/80 hover:text-[#FF6B00] text-sm transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Контакты
            </div>
            <a
              href="tel:+79223829669"
              data-testid="footer-phone"
              className="flex items-center gap-3 text-white hover:text-[#FF6B00] transition-colors mb-4"
            >
              <Phone className="w-4 h-4 text-[#FF6B00]" />
              <span className="font-display text-lg font-semibold">
                +7 922 382-96-69
              </span>
            </a>
            <a
              href="mailto:bizoralogistikgroup@yandex.ru"
              data-testid="footer-email"
              className="flex items-center gap-3 text-white/80 hover:text-[#FF6B00] transition-colors"
            >
              <Mail className="w-4 h-4 text-[#FF6B00]" />
              <span className="text-sm">bizoralogistikgroup@yandex.ru</span>
            </a>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <div>© {year} ООО «Бизора Логистик». Все права защищены.</div>
          <div className="uppercase tracking-[0.2em]">
            B2B · Оптовая торговля · Россия
          </div>
        </div>
      </div>
    </footer>
  );
}
